"use strict";

var _interopRequireDefault = require("/root/workspace/follow-book_follow-book-admin_fMUT/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPath = getPath;
exports.upload = upload;
exports.ossUrl = ossUrl;
exports.client = void 0;

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/follow-book_follow-book-admin_fMUT/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _qs = _interopRequireDefault(require("qs"));

var _aliOss = _interopRequireDefault(require("ali-oss"));

var client = new _aliOss.default({
  region: process.env.VUE_APP_OSS_REGION,
  accessKeyId: process.env.VUE_APP_OSS_ACCESS_KEY_ID,
  // 云账号AccessKey有所有API访问权限，建议遵循阿里云安全最佳实践，创建并使用STS方式来进行API访问
  accessKeySecret: process.env.VUE_APP_OSS_ACCESS_KEY_SECRET,
  bucket: process.env.VUE_APP_OSS_BUCKET
});
exports.client = client;

function getPath(path) {
  if (!path) {
    return undefined;
  }

  return "".concat(process.env.VUE_APP_OSS_UPLOAD_PREFIX, "/").concat(path);
}

function upload(_x, _x2) {
  return _upload.apply(this, arguments);
}

function _upload() {
  _upload = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(file, name) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return client.multipartUpload("".concat(process.env.VUE_APP_SYSTEM_ENV_NAME, "/").concat(name), file);

          case 2:
            return _context.abrupt("return", name);

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _upload.apply(this, arguments);
}

function ossUrl(path) {
  var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'thumbnail_progressive';

  if (!path) {
    return undefined;
  }

  var query = style ? _qs.default.stringify({
    'x-oss-process': "style/".concat(style)
  }) : undefined;
  var url = "".concat(process.env.VUE_APP_OSS_URL).concat(process.env.VUE_APP_SYSTEM_ENV_NAME, "/").concat(path);
  return query ? "".concat(url, "?").concat(query) : url;
}